import { useState } from "react";

function read<T>(
  key: string,
  fallback: T,
  isValid: (value: unknown) => value is T,
): T {
  try {
    const raw = window.localStorage.getItem(key);
    if (raw === null) return fallback;
    const parsed: unknown = JSON.parse(raw);
    return isValid(parsed) ? parsed : fallback;
  } catch {
    return fallback;
  }
}

/**
 * `useState` dont la valeur est conservée dans le navigateur (préférence
 * d'affichage, filtre…). Le stockage peut être indisponible ou corrompu : la
 * valeur par défaut prend alors le relais sans erreur.
 */
export default function useLocalStorageState<T>(
  key: string,
  fallback: T,
  isValid: (value: unknown) => value is T,
): [T, (value: T) => void] {
  const [value, setValue] = useState<T>(() => read(key, fallback, isValid));

  function setAndStore(next: T) {
    setValue(next);
    try {
      window.localStorage.setItem(key, JSON.stringify(next));
    } catch {
      // Stockage indisponible (navigation privée, quota) : la préférence vaut pour la session.
    }
  }

  return [value, setAndStore];
}
